module.exports = __webpack_public_path__ + "img/workshift-plan1.4c267e57.jpg";